document.addEventListener('DOMContentLoaded', () => {
  const scarcity = document.querySelector('[data-scarcity]');
  if (!scarcity) return;

  const bar = scarcity.querySelector('.nn-scarcity__bar');
  const label = scarcity.querySelector('.nn-scarcity__label');
  const editionSize = Number(scarcity.getAttribute('data-edition-size')) || 99;
  const soldMetafield = Number(scarcity.getAttribute('data-sold')) || 0;

  const update = () => {
    if (scarcity.hasAttribute('data-unmapped')) {
      if (label) label.textContent = `Limited to ${editionSize} pairs worldwide`;
      return;
    }

    const remaining = Math.max(0, Number(scarcity.getAttribute('data-qty')) || 0);
    const sold = Math.max(0, Number(scarcity.getAttribute('data-sold')) || soldMetafield || 0);
    const width = Math.max(remaining > 0 ? 4 : 0, Math.min(100, Math.round((remaining / editionSize) * 100)));
    if (bar) bar.style.width = `${width}%`;

    if (label) {
      if (remaining <= 0) {
        label.textContent = `Edition complete — ${editionSize} of ${editionSize} claimed`;
      } else {
        const nextNumber = Math.min(editionSize, sold + 1);
        label.textContent = `Edition ${nextNumber} of ${editionSize} · ${remaining} remaining`;
      }
    }

    scarcity.setAttribute('data-remaining', String(remaining));
  };

  update();
});
